import cn from "classnames"

import { SurveyList } from "modules/NewClientSurvey/common"
import { Header } from "modules/NewClientSurvey/components/QuestionnaireCards/components/Header"
import style from "modules/NewClientSurvey/components/QuestionnaireCards/style.module.scss"
import { Box, Button, Text } from "ui-kit/components-branded"

interface Props {
    items: SurveyList[]
    isLoading: boolean
    slug: string | undefined
    onClickCard: (slug: string) => void
}

export function QuestionnaireCards({ items, isLoading, slug, onClickCard }: Props) {
    const oneOfPimary = items.some((i) => i.is_primary)
    const itemsLength = items.length

    return (
        <>
            <Header />
            <div className={style.list}>
                {items.map((item) => {
                    return (
                        <div
                            className={cn(style.item, {
                                [style.nonActive]:
                                    oneOfPimary && !item.is_primary && itemsLength === 3,
                                [style.active]: item.is_primary && itemsLength === 3,
                                [style.maxOneCard]: itemsLength < 3,
                            })}
                            key={item.url}
                            onClick={() => onClickCard(item.url)}
                        >
                            <Box className={style.box}>
                                <div className={style.content}>
                                    <div className={style.header}>
                                        <div className={style.title}>{item.title}</div>
                                        <Text className={style.description}>{item.subtitle}</Text>
                                    </div>
                                </div>
                                {item.image && (
                                    <div className={style.img}>
                                        <img src={`${item.image}`} alt="" />
                                    </div>
                                )}
                                <Button
                                    color={item.is_primary ? "primary" : undefined}
                                    isLoading={isLoading && item.url === slug}
                                    className={style.button}
                                >
                                    Начать
                                </Button>
                            </Box>
                        </div>
                    )
                })}
            </div>
        </>
    )
}
